module.exports = __webpack_public_path__ + "media/icons/float-right-b06480a9.svg";